import { CloseOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { Button } from 'antd';
import React from 'react';

interface IProps {
  icon?: React.ReactElement;
  title?: string | undefined;
  onClick?: React.MouseEventHandler<HTMLElement> | undefined;
}

export const DrawerCloseButton: React.FC<IProps> = ({ icon = <CloseOutlined />, onClick }) => {
  return <Button title={L('Close')} type="text" icon={icon} onClick={onClick} />;
};
